// Steps/PushMessageContent.js - Step 4 Component
import { useContext, useEffect } from 'react';
import { Box, Typography, Grid, TextField, Paper, Card, CardContent, Avatar} from '@mui/material';
import { NotificationsActive, Title,} from '@mui/icons-material';
import { NotificationDataContext } from '../../AddEditNotification';
import { useForm, Controller } from 'react-hook-form';
import NavigationButton from '../NavigationButton';

const PushMessageContent = () => {
    const { notificationData, setNotificationData,initialState,steps,activeStep,setActiveStep, setCompletedSteps } = useContext(NotificationDataContext);
    const {handleSubmit, formState: { isDirty }, control,watch,setValue} = useForm({
        mode: 'onChange',
        defaultValues: {
            customerFilters:initialState.customerFilters,
            expertFilters: initialState.expertFilters
        }
    });
    
    const completeStep = (data) => {
        console.log('Audience Selection Data:', data);
        setNotificationData(prev => ({
            ...prev,
            title:data.title,
            body:data.body
        }))
        if (activeStep < steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setCompletedSteps((prev) => {
                prev.add(activeStep);
                return new Set(prev);
            });
        }
    }
    useEffect(()=>{
        if(notificationData.title){
            setValue('title',notificationData.title,{shouldValidate: true,shouldDirty: true});
        }
        if(notificationData.body){
            setValue('body',notificationData.body,{shouldValidate: true,shouldDirty: true});
        }
    },[])


    return (
        <Box component={'form'} onSubmit={handleSubmit(completeStep)}>
            <Card>
                <CardContent sx={{ height:'max-content' }}>
                    <Typography gutterBottom sx={{ mb: 1, fontWeight: 600 ,fontSize:'0.85rem'}}>
                        Notification Content
                    </Typography>

                    <Grid container spacing={3}>
                        {/* Message Composition */}
                        <Grid item xs={12} md={8}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="subtitle1" gutterBottom sx={{ 
                                        fontWeight: 600, 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: 1,
                                        mb: 2
                                    }}>
                                        <Title color="primary" />
                                        Compose Your Message
                                    </Typography>
                                    <Controller
                                        control={control}
                                        name="title"
                                        rules={{
                                            required: 'please enter push notification title'
                                        }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Notification Title"
                                                // value={notificationData.title}
                                                onChange={(e) => {
                                                    // remove extra spaces and leading spaces
                                                    const cleanedValue = e.target.value
                                                        .replace(/\s+/g, ' ') // Replace multiple spaces with single space
                                                        .trimStart(); // Remove leading spaces
                                                    field.onChange(cleanedValue);
                                                }}
                                                size="small"
                                                sx={{ mb: 2 }}
                                                InputProps={{
                                                    style: { fontSize: '0.8rem' }
                                                }}
                                                InputLabelProps={{
                                                    style: { fontSize: '0.8rem' }
                                                }}
                                                error={!!error}
                                                helperText={error?.message}
                                                // helperText="Keep it concise and attention-grabbing"
                                            />
                                        )}
                                    />
                                    <Controller
                                        control={control}
                                        name="body"
                                        rules={{
                                            required: 'please enter push notification body',
                                            validate: value => value.length <= 200 || 'Body exceeds 200 characters'
                                        }}
                                        render={({ field, fieldState: { error } }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                label="Notification Body"
                                                multiline
                                                rows={4}
                                                // value={notificationData.body}
                                                // onChange={handleBodyChange}
                                                onChange={(e) => {
                                                    // remove extra spaces and leading spaces also limit to 200 characters
                                                    const cleanedValue = e.target.value
                                                        .replace(/\s+/g, ' ') // Replace multiple spaces with single space
                                                        .trimStart(); // Remove leading spaces
                                                    if (cleanedValue?.length <= 200) {
                                                        field.onChange(cleanedValue);
                                                        return;
                                                    }
                                                    const limitedValue = cleanedValue.slice(0, 200);
                                                    field.onChange(limitedValue);
                                                }}
                                                size="small"
                                                InputProps={{
                                                    style: { fontSize: '0.75rem' }
                                                }}
                                                InputLabelProps={{
                                                    style: { fontSize: '0.8rem' }
                                                }}
                                                error={!!error}
                                                helperText={`${watch('body')?.length}/200 characters recommended`}
                                            />
                                        )}
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            {/* Message Preview */}
                                    {notificationData.title && notificationData.body && (
                                        <Box sx={{}}>
                                            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, mb: 1 }}>
                                                Preview:
                                            </Typography>
                                            <Paper 
                                                sx={{ 
                                                    p: 2, 
                                                    bgcolor: 'grey.50', 
                                                    border: '1px dashed', 
                                                    borderColor: 'grey.300',
                                                    // maxWidth: 300
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                                                    <Avatar sx={{ width: 24, height: 24, bgcolor: 'primary.main' }}>
                                                        <NotificationsActive sx={{ fontSize: 14 }} />
                                                    </Avatar>
                                                    <Box sx={{ flex: 1 }}>
                                                        <Typography variant="subtitle2" sx={{ 
                                                            fontWeight: 600, 
                                                            fontSize: '0.8rem',
                                                            lineHeight: 1.2,
                                                            mb: 0.5
                                                        }}>
                                                            {watch('title')}
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ 
                                                            fontSize: '0.7rem',
                                                            color: 'text.secondary',
                                                            lineHeight: 1.3
                                                        }}>
                                                            {watch('body')}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Paper>
                                        </Box>
                                    )}
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {/* Navigation Buttons */}
            {/* <PermissionGuard feature='notification' permission={'canCreate'}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                    <Button
                        onClick={handleBack}
                        sx={{ fontSize: '0.75rem' }}
                    >
                        Back
                    </Button>
                    <Button
                        variant="contained"
                        type="submit"
                        disabled={!isDirty}
                        sx={{ fontSize: '0.75rem' }}
                    >
                        Next
                    </Button>
                </Box>
            </PermissionGuard> */}
            <NavigationButton isDirty={isDirty}/>
        </Box>
    );
};

export default PushMessageContent;